import { useProfile } from '../../api/queries/useProfile';

import styles from './ProfileInfo.module.css';

const ProfileInfo: React.FC = () => {
  const { data } = useProfile();

  if (data === undefined) {
    return null;
  }

  const { result: profile } = data;

  return (
    <div data-hj-suppress className={styles.profileContainer}>
      <span className={styles.badge}>{profile?.greetingName.charAt(0)}</span>
      <span className={styles.title}>{profile?.greetingName}</span>
    </div>
  );
};

export { ProfileInfo };
